import { PaymentStatus } from '../types/payment-statuses';
import { PillColor } from '../components/Pill/Pill';

export const paymentStatusToTranslationKey = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentStatus.PAID:
      return 'payment.status.paid';
    case PaymentStatus.NOT_PAID:
      return 'payment.status.not_paid';
    case PaymentStatus.PARTIALLY_PAID:
      return 'payment.status.partially_paid';
    case PaymentStatus.PENDING:
      return 'payment.status.pending';
    case PaymentStatus.OVERDUE:
      return 'payment.status.overdue';
    case PaymentStatus.FAILED:
      return 'payment.status.failed';
    case PaymentStatus.REFUNDED:
      return 'payment.status.refunded';
    default:
      return 'payment.status.unknown';
  }
};

export const paymentStatusToAbbreviatedTranslationKey = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentStatus.PAID:
      return 'payment.status.paid_short';
    case PaymentStatus.NOT_PAID:
      return 'payment.status.not_paid_short';
    case PaymentStatus.PARTIALLY_PAID:
      return 'payment.status.partially_paid_short';
    case PaymentStatus.PENDING:
      return 'payment.status.pending_short';
    case PaymentStatus.OVERDUE:
      return 'payment.status.overdue_short';
    case PaymentStatus.FAILED:
      return 'payment.status.failed_short';
    case PaymentStatus.REFUNDED:
      return 'payment.status.refunded_short';
    default:
      return 'payment.status.unknown_short';
  }
};

export const paymentStatusToPillColor = (status: PaymentStatus): PillColor => {
  switch (status) {
    case PaymentStatus.PAID:
      return 'green';
    case PaymentStatus.NOT_PAID:
      return 'red';
    case PaymentStatus.PARTIALLY_PAID:
      return 'orange';
    case PaymentStatus.PENDING:
      return 'yellow';
    case PaymentStatus.OVERDUE:
      return 'red';
    case PaymentStatus.FAILED:
      return 'red';
    case PaymentStatus.REFUNDED:
      return 'blue';
    default:
      return 'grey';
  }
}; 